<template>
  <ElButton class="stroke-button" v-bind="$attrs" plain v-on="$listeners">
    <slot />
  </ElButton>
</template>

<script>
export default {
  name: 'StrokeButton',
  inheritAttrs: false,
};
</script>
<style lang="scss">
// To increase specificity
.stroke-button.stroke-button {
  background-color: #fff;
}
</style>
